import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import API from "../../api"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {
  Row,
  Col,
  Spinner,
  CardTitle,
  Form,
  Label,
  ModalBody,
  Button,
  Progress,
  Modal,
} from "reactstrap"
import { withRouter } from "react-router"
import { ToastContainer, toast, Slide } from "react-toastify"
import { Link } from "react-router-dom"
import Select from "react-select"
import apis from "../../api"

const DataTableSchedulesGrp = props => {
  const [loading, setLoading] = useState(false)
  const [orders, setOrders] = useState([])
  const [annee, setAnnee] = useState("")
  const [imp, setImp] = useState(0)
  const [view, setView] = useState(0)
  const [add, setAdd] = useState(0)
  const pageOptions = {
    loading: true,
    hidePageListOnlyOnePage: true,
    totalSize: orders.length,
    page: 1,
    nextPageText: "Suivant",
    prePageText: "Précédent",
    sizePerPage: 50,
    alwaysShowAllBtns: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "30",
        value: 30,
      },
      {
        text: "All",
        value: orders.length,
      },
    ],
  }
  const [departement, setDepartement] = useState([])
  const [selectDepartement, setSelectDepartement] = useState("")
  const [modalAffiche, setModalAffiche] = useState(false)
  const [uploadPercent, setUploadPercent] = useState(0)
  const [cloture, setCloture] = useState(0)
  const [id, setId] = useState("")
  const [affichage, setAffichage] = useState(0)
  const [modal, setModal] = useState(false)
  const NoDataIndication = () => (
    <h6 style={{ textAlign: "center" }}>No record to display</h6>
  )
  const Columns = () => [
    {
      dataField: "group_cour",
      text: "Group Cour",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "group_td",
      text: "Group TD",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "Emploi",
      isDummyField: true,
      text: "Emploi Semestre "+props.semestre,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        view === 1 ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Link to={"/EmploiGroup?id=" + row.id + "/" + props.semestre}>
              <i
                style={{
                  color: "green",
                  cursor: "pointer",
                }}
                className="fas fa-eye"
              ></i>
            </Link>
          </div>
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#a7a3a3", cursor: "pointer" }}
              className="fas fa-eye"
            ></i>
          </div>
        ),
    },
    {
      dataField: "Téléchargement",
      isDummyField: true,
      text: "Téléchargement",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        imp === 1 ? (
          <a
            href={
              "https://scolarite.flshs.edura.backcresus-institut.ovh/api/impression_group_shedules/" +
              row.id +
              "/" +
              props.semestre +
              "/" +
              annee
            }
            target="_blank"
            rel="noreferrer"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <i
              style={{ color: "#955cd5", cursor: "pointer" }}
              // onClick={""}
              className="fas fa-file-download"
            ></i>
          </a>
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#a7a3a3", cursor: "pointer" }}
              className="fas fa-file-download"
            ></i>
          </div>
        ),
    },
    {
      dataField: "id",
      isDummyField: true,
      text: "Afficher l'emploi de groupe dans l'espace étudiant",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        cloture !== 1 ? (
          add === 1 ? (
            row.affichage === 0 ? (
              <i
                style={{
                  color: "#ff0000",
                  cursor: "pointer",
                  fontSize: "18px",
                }}
                onClick={() => toggleAffiche(row)}
                className="bx bx-bell bx-tada"
                title="Afficher l'emploi dans leur espace"
              ></i>
            ) : (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <i
                  style={{
                    color: "#a7a3a3",
                    cursor: "pointer",
                    fontSize: "18px",
                  }}
                  onClick={() => toggleAffiche(row)}
                  className="bx bx-bell bx-tada"
                  title="Masquer l'emploi dans leur espace"
                ></i>
              </div>
            )
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{
                  color: "#a7a3a3",
                  cursor: "pointer",
                  fontSize: "18px",
                }}
                className="bx bx-bell bx-tada"
                title="Vous n'avez pas d'accès"
              ></i>
            </div>
          )
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#a7a3a3", cursor: "pointer", fontSize: "20px" }}
              title="Année clôturée"
              className="bx bx-bell bx-tada"
            ></i>
          </div>
        ),
    },
  ]
  const toggleAffiche = row => {
    setModalAffiche(true)
    setAffichage(row.affichage)
    setId(row.id)
  }
  const toggle = row => {
    setModal(true)
    setId(row.id)
  }
  const closeModal = () => {
    setModalAffiche(false)
  }
  const closeModal1 = () => {
    setModal(false)
  }

  const { SearchBar } = Search
  //
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id
  useEffect(async () => {
    var cloture_annee = JSON.parse(localStorage.getItem("cloture"))
    setCloture(cloture_annee)
    const userAuth = JSON.parse(localStorage.getItem("UserMenu"))
    const typeArticleSubMenu = userAuth.find(user =>
      user.sous_menu.some(subMenu => subMenu.sous_menu === "Emploi groupes")
    )
    setImp(typeArticleSubMenu.sous_menu[0].imp)
    setView(typeArticleSubMenu.sous_menu[0].view)
    setAdd(typeArticleSubMenu.sous_menu[0].add)

    var userAuthScolarite = JSON.parse(
      localStorage.getItem("userAuthScolarite")
    )
    var annee_id = userAuthScolarite.user.annee_id
    setAnnee(annee_id)

    const resDepartement = await API.get("departement/select").then(
      resDepartement => {
        setDepartement(resDepartement.data.Departement)
        setSelectDepartement("")
      }
    )
    const res = await API.post("emploi/group/list", {
      semestre_id: props.semestre,
      annee_id: annee_id,
    }).then(res => {
      setOrders(res.data.groups)
    })
    setLoading(true)
  }, [props.semestre])
  const search = async () => {
    if (selectDepartement.value != "" || selectDepartement.value != null) {
      setOrders([])
      const res = await API.post("group/get_by_dep", {
        semestre_id: props.semestre,
        departement_id: selectDepartement.value,
        annee_id,
      }).then(res => {
        setOrders(res.data.groups)
      })
    } else {
      toast.error("⛔ département est obligatroire !", {
        containerId: "A",
      })
    }
  }
  const searchAll = async () => {
    var userAuthScolarite = JSON.parse(
      localStorage.getItem("userAuthScolarite")
    )
    var annee_id = userAuthScolarite.user.annee_id
    const res = await API.post("emploi/group/list", {
      semestre_id: props.semestre,
      annee_id: annee_id,
    }).then(res => {
      setOrders(res.data.groups)
      setLoading(true)
    })
  }
  const afficherAll = async () => {
    const res = await apis
      .post("emploi/affichage", {
        annee_id: annee_id,
        user_id,
        affichage: 1,
      })
      .then(res => {
        API.post("emploi/group/list", {
          annee_id,
          semestre_id: props.semestre,
        }).then(resA => {
          setModal(false)
          setOrders(resA.data.groups)
          setLoading(true)
        })
      })
  }
  const masquerAll = async () => {
    const res = await apis
      .post("emploi/affichage", {
        annee_id: annee_id,
        user_id,
        affichage:0,
      })
      .then(res => {
        API.post("emploi/group/list", {
          annee_id,
          semestre_id: props.semestre,
        }).then(resA => {
          setModal(false)
          setOrders(resA.data.groups)
          setLoading(true)
        })
      })
  }
  const toggleNotifier = async () => {
    try {
      const affiche = affichage === 1 ? 0 : 1
      const res = await apis
        .post("emploi/affichage", {
          grouptd_id: id,
          annee_id: annee_id,
          user_id,
          affichage: affiche,
        })
        .then(res => {
          API.post("emploi/group/list", {
            annee_id,
            semestre_id: props.semestre,
          }).then(resA => {
            setOrders(resA.data.groups)
            setModalAffiche(false)
            setAffichage(affichage)
            setLoading(true)
          })
        })
    } catch (error) {
      console.error("Erreur lors de la notification :", error)
    }
  }

  return (
    <React.Fragment>
      <div>
        {loading ? (
          <Row className="mt-4">
            <Col xs="12">
              <ToolkitProvider
                keyField="id"
                data={orders}
                columns={Columns()}
                search
                bootstrap4
              >
                {toolkitProps => (
                  <div>
                    <div>
                      <CardTitle style={{ color: "#556ee6" }} className="h4">
                        Critéres de Recherches
                      </CardTitle>
                      <Form className="mt-4">
                        <Row>
                          <Col lg="6">
                            <div className="mb-3">
                              <Label for="basicpill-lastname-input2">
                                Département :
                              </Label>
                              <Select
                                options={departement}
                                isSearchable={true}
                                // isClearable={true}
                                value={selectDepartement}
                                onChange={e => setSelectDepartement(e)}
                              />
                            </div>
                          </Col>

                          <Col lg="6" style={{ padding: "26px 35px" }}>
                            <button
                              type="button"
                              style={{
                                backgroundColor: "#761C19",
                                borderColor: "#761C19",
                              }}
                              className="btn btn-success mb-2 me-2"
                              onClick={search}
                            >
                              Rechercher
                            </button>
                            <button
                              type="button"
                              style={{
                                backgroundColor: "#761C19",
                                borderColor: "#761C19",
                              }}
                              className="btn btn-success mb-2 me-2"
                              onClick={searchAll}
                            >
                              Afficher tout
                            </button>
                            <button
                              type="button"
                              style={{
                                backgroundColor: "#1f7619",
                                borderColor: "#1f7619",
                              }}
                              className="btn btn-success mb-2 me-2"
                              onClick={toggle}
                            >
                              Afficher / masquer emploi pour tous les groupes
                            </button>
                            {/*<button*/}
                            {/*  type="button"*/}
                            {/*  style={{*/}
                            {/*    backgroundColor: "#999f15",*/}
                            {/*    borderColor: "#999f15",*/}
                            {/*  }}*/}
                            {/*  className="btn btn-success mb-2 me-2"*/}
                            {/*  onClick={searchAll}*/}
                            {/*>*/}
                            {/*  Afficher emploi pour tous les étudiants par*/}
                            {/*  département*/}
                            {/*</button>*/}
                          </Col>
                        </Row>
                      </Form>
                      <div className="mb-3 row" style={{ display: "flex" }}>
                        <div className="col-md-6 mb-3 row">
                          <div className="col-md-8 search-box-etd">
                            <div
                              className="search-box me-2 mb-2 d-inline-block"
                              style={{ width: "100%" }}
                            >
                              <div className="position-relative">
                                <SearchBar {...toolkitProps.searchProps} />
                                <i className="bx bx-search-alt search-icon" />
                              </div>
                            </div>
                          </div>
                        </div>
                        {imp === 1 ? (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                            }}
                            className="col-md-6 mb-3 row"
                          >
                            <div
                              style={{ textAlign: "right" }}
                              className="col-md-6 select-action"
                            >
                              <a
                                href={
                                  "https://scolarite.flshs.edura.backcresus-institut.ovh/api/impression_groups_shedules" +
                                  "/" +
                                  props.semestre +
                                  "/" +
                                  annee
                                }
                                target="_blank"
                                rel="noreferrer"
                              >
                                <button className="btn btn-primary btn btn-primary">
                                  <i className="fas fa-file-download font-size-16 align-middle me-2"></i>
                                  Emplois groupes
                                </button>
                              </a>
                            </div>
                            {selectDepartement.value !== undefined ? (
                              <a
                                className="col-md-6"
                                href={
                                  "https://scolarite.flshs.edura.backcresus-institut.ovh/api/impression_group_shedules_dep" +
                                  "/" +
                                  selectDepartement.value +
                                  "/" +
                                  props.semestre +
                                  "/" +
                                  annee
                                }
                                target="_blank"
                                rel="noreferrer"
                              >
                                <button className="btn btn-primary btn btn-primary">
                                  <i className="fas fa-file-download font-size-16 align-middle me-2"></i>
                                  Emplois groupes par département
                                </button>
                              </a>
                            ) : null}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <BootstrapTable
                      keyField="id" // 🔁 À remplacer si "id" n’est pas unique !
                      wrapperClasses="table-responsive"
                      noDataIndication={() => <NoDataIndication />}
                      striped={false}
                      bordered={false}
                      classes={"table align-middle table-nowrap"}
                      headerWrapperClasses={"table-light"}
                      hover
                      pagination={paginationFactory(pageOptions)}
                      {...toolkitProps.baseProps}
                    />
                  </div>
                )}
              </ToolkitProvider>
            </Col>
          </Row>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              <Spinner type="grow" className="ms-6" color="primary" />
            </div>
            <h4
              style={{ textAlign: "center", marginTop: "2%" }}
              className="ms-6"
            >
              {" "}
              En cours ...{" "}
            </h4>
          </div>
        )}
      </div>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
      <Modal isOpen={modalAffiche} toggle={closeModal} centered={true}>
        <div
          className="modal-header"
          style={{
            width: "100% !important",
            justifyContent: "center !important",
            margin: "0 auto",
            fontSize: "17px",
          }}
          // toggle={closeModal}
        >
          {"Afficher l'emploi du temps dans l'espace étudiant"}
        </div>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>
                {
                  "Êtes-Vous sûr d'afficher l'emploi du temps dans l'espace étudiant"
                }
              </p>
            </div>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              {affichage == 0 ? (
                <div>
                  <Button
                    color="info"
                    className="btn-rounded"
                    onClick={toggleNotifier}
                  >
                    <i
                      style={{ color: "white" }}
                      className="far fa-thumbs-up"
                    ></i>
                    {"Afficher"}
                  </Button>
                </div>
              ) : (
                <div>
                  <Button
                    color="warning"
                    className="btn-rounded"
                    onClick={toggleNotifier}
                  >
                    <i
                      style={{ color: "white" }}
                      className="far fa-thumbs-up"
                    ></i>
                    {"Masquer"}
                  </Button>
                </div>
              )}

              <div>
                <Button
                  onClick={closeModal}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  {"Annuler"}
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modal} toggle={closeModal1} centered={true}>
        <div
          className="modal-header"
          style={{
            width: "100% !important",
            justifyContent: "center !important",
            margin: "0 auto",
            fontSize: "17px",
          }}
          // toggle={closeModal}
        >
          {"Afficher / masquer l'emploi du temps dans l'espace étudiant"}
        </div>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>
                {
                  "Êtes-Vous sûr d'afficher / masquer l'emploi du temps dans l'espace étudiant"
                }
              </p>
            </div>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded"
                  onClick={afficherAll}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  {"Afficher"}
                </Button>
              </div>
              <div>
                <Button
                  onClick={closeModal1}
                  color="warning"
                  className="btn-rounded "
                >
                  {"Annuler"}
                </Button>
              </div>
              <div>
                <Button
                  color="danger"
                  className="btn-rounded"
                  onClick={masquerAll}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  {"Masquer"}
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

export default withRouter(DataTableSchedulesGrp)
DataTableSchedulesGrp.propTypes = {
  orders: PropTypes.array,
  history: PropTypes.object,
  t: PropTypes.any,
  semestre: PropTypes.any,
}
